export default __webpack_public_path__ + "static/media/add-user.6a44db76.svg";